import { Color, setColor } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const WordSliderContainer = styled.div`
  display: inline;
`;

export const StaticHeadlineText = styled.span`
  position: relative;
  z-index: 2;
`;

export const TypedInText = styled.span<{ textColor: Color }>`
  color: ${({ textColor }) => setColor(textColor)};
  font-weight: inherit;
  display: inline;

  @media all and (max-width: ${layout.md}) {
    display: block;
  }
`;

// Avoids jumping height if TypedInText is empty
export const TypedInTextSpacer = styled.span`
  display: inline-block;
`;
